import { render, staticRenderFns } from "./Clusters.vue?vue&type=template&id=058379e2&scoped=true&"
import script from "./Clusters.vue?vue&type=script&lang=js&"
export * from "./Clusters.vue?vue&type=script&lang=js&"
import style0 from "./Clusters.vue?vue&type=style&index=0&id=058379e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058379e2",
  null
  
)

export default component.exports